function doCardCarousel() {
  if (customElements.get("card-carousel")) return null;

  class CardCarousel extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector(".cardCarousel");
      this.init();
    }
    init() {
      this.executeSwiper();
    }

    executeSwiper() {
      if (this.sliderElement == null) return;
      const swiper = new Swiper(this.sliderElement, {
        direction: "horizontal",
        slidesPerView: 1,
        touchStartForcePreventDefault: true,

        slidesPerView: "auto",
        loop: true,

        navigation: {
          nextEl: ".cardCarousel-next",
          prevEl: ".cardCarousel-prev",
        },
      });
    }
  }
  customElements.define("card-carousel", CardCarousel);
}
doCardCarousel();
